<script lang="ts" setup>
import { AbcHeading, AbcIcon } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import { Color, Size } from "@/abc-dsk/options";
import type { Word } from "@/common/types/vocab";

defineProps<{
  word: Word;
}>();
const emit = defineEmits(["close"]);
const { t } = useI18n();
const onClose = () => emit("close");
</script>

<template>
  <TgModal alert :size="Size.Md" :color="Color.Yellow" @close="onClose()">
    <div class="duplicate-lemma-warning-modal">
      <div>
        <div class="duplicate-lemma-warning-modal__heading">
          <AbcIcon name="exclamation" color="yellow" />
          <AbcHeading size="md" tag="h2" color="black">
            {{ t("vocab.vocabList.duplicateLemmaModal.heading") }}
          </AbcHeading>
        </div>
        <p class="duplicate-lemma-warning-modal__text">
          {{
            t("vocab.vocabList.duplicateLemmaModal.text", {
              word: word.lemma,
              wordclass: word.lemmaWordclass.short ? `(${word.lemmaWordclass.short})` : ""
            })
          }}
        </p>
      </div>
      <div class="duplicate-lemma-warning-modal__button-container">
        <TgButton color="yellow" @click="onClose()">{{ t("general.understood") }}</TgButton>
      </div>
    </div>
  </TgModal>
</template>

<style lang="less" scoped>
.duplicate-lemma-warning-modal {
  &__heading {
    display: flex;
    gap: 11px;
    align-items: center;
  }

  &__text {
    margin: 10px 0 0;
  }

  &__button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
  }
}
</style>
